import React, { useRef, useState } from "react";
import InputField from "../form/InputField";
import { CustomButton } from "./Buttons";
import { useInitOrderMutation } from "@/redux/feature/order/orderApi";
import { useAppDispatch, useAppSelector } from "@/redux/hooks/hooks";
import { useNavigate } from "react-router-dom";
import { TResponse } from "@/types/types";
import toast from "react-hot-toast";
// import { addOrderDetails } from "@/redux/feature/createOrder/orderSlice";
// import { resetAllScriptDetails } from "@/redux/feature/createOrder/scriptDetails/scriptDetailsSlice";
// import { resetAllActorDetails } from "@/redux/feature/createOrder/actorDetails/actorDetailsSlice";
// import { resetAllVideoEditDetails } from "@/redux/feature/createOrder/videoEditingDetails/VideoEditingDetailsSlice";
// import { resetPlanSelection } from "@/redux/feature/createOrder/planSelection/planSelectionSlice";

const CreateProjectModal = () => {
  const [projectName, setProjectName] = useState("");

  const [initOrder] = useInitOrderMutation();
  const { user } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleCreateOrder = async () => {
    if (!projectName) {
      inputRef.current?.focus();
      toast.error("Please Give a project name");
      return;
    }
    const payload = {
      client_email: user?.email,
      projectName,
    };
    try {
      const res = (await initOrder(payload)) as TResponse<any>;
      if (res.error) {
        toast.error("Something Went Wrong");
      } else {
        // dispatch(
        //   // addOrderDetails({
        //   //   field: "order_id",
        //   //   value: res?.data?.data._id,
        //   // })
        // );
        // plan selection
        // Script details , actor and video edit details
        //have to clear
        // dispatch(resetPlanSelection())
        // dispatch(resetAllScriptDetails());
        // dispatch(resetAllActorDetails());
        // dispatch(resetAllVideoEditDetails());
        navigate("/orders/create-order/plan-selection");
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleCreateOrder();
    }
  };
  return (
    <div className="text-center p-2 w-full">
      <h2 className="text-body-medium font-semibold  text-[#101828]">
        Name Your Project
      </h2>
      <p className="text-[#475467] pt-2 text-caption-large">
        Naming your project makes it easier <br /> in managing orders
      </p>

      <div className="text-start pt-[20px] pb-[32px]">
        <InputField
          ref={inputRef}
          onKeyDown={handleKeyDown} 
          value={projectName}
          onChange={(e) => setProjectName(e.target.value)}
          name="projectName"
          label="Project Name"
          placeholder="Enter here.."
        />
      </div>
      <CustomButton
        onClick={handleCreateOrder}
        padding="10px 18px"
        border="1px solid"
        borderRadius="8px"
        className="w-full"
        fontSize="16px"
        fontWeight="600"
        backgroundColor="#17457D"
      >
        Create Project
      </CustomButton>
    </div>
  );
};

export default CreateProjectModal;
